import { LicenseDetailWithIds, MineDocumentsStatus, MineDocumentsStatusFromBack } from '@/interfaces/common/common.interface';
import { CompleteLicense } from '@/interfaces/dashboard/licenses';
import { Infractions } from '@/interfaces/my-profile/my-profile';
import { Asset, LicenseType, VehicleType, Zone } from '@/interfaces/new-license-request/new-license-request-interfaces';
import { CacheService } from '@/utils/cacheService/cache.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor(
    private http: HttpClient,
    private cacheService: CacheService,
  ) { }

  getAllAssets(): Observable<Asset[]> {
    return this.cacheService.save<Asset[]>('getAllAssets', 24 * 60, this.http.get<Asset[]>('/Common/Assets'));
  }

  getZonesByAsset(assetId: number): Observable<Zone[]> {
    const equipmentLicenseId = 1;
    return this.cacheService.save<Zone[]>(`getZonesByAsset${assetId}`, 24 * 60, this.http.get<Zone[]>(`/Common/ConductionZones?assetId=${assetId}&equipmentLicenseId=${equipmentLicenseId}`));
  }

  getVehiclesTypesByAsset(assetId: number): Observable<LicenseType[]> {
    const source$ = this.http.get<LicenseType[]>(`/Common/Equipments?assetId=${assetId}`)
      .pipe(
        map(
          (vehicles: VehicleType[]) => vehicles.sort((a, b) => {
            if (a && b && a.name && b.name) {
              return a.name > b?.name ? 1 : -1;
            }
            return 0;
          }),
        ),
      );
    return this.cacheService.save<Zone[]>(`getVehiclesTypesByAsset${assetId}`, 24 * 60, source$);
  }

  getLicenseTypesByAsset(assetId: number): Observable<LicenseType[]> {
    const source$ = this.http.get<LicenseType[]>(`/Common/EquipmentLicenses?assetId=${assetId}&equipmentId=1`);
    return this.cacheService.save<Zone[]>(`getLicenseTypesByAsset${assetId}`, 24 * 60, source$);
  }

  getMineDocumentsStatus(): Observable<MineDocumentsStatus[]> {
    const source$ = this.http.get<MineDocumentsStatusFromBack[]>('/Requirement/DocumentStatus')
      .pipe(map((backDocumentStatus) => backDocumentStatus
        .map(({ id, description }) => ({ id, name: description }))));
    return this.cacheService.save<Zone[]>('getMineDocumentsStatus', 24 * 60, source$);
  }

  getLicenseByUser(mdmid: string): Observable<CompleteLicense[]> {
    const source$ = this.http.get<CompleteLicense[]>(`MyProfile/LicensesByUser?userId=${mdmid}`);
    return this.cacheService.save<CompleteLicense[]>(`LicensesByUser${mdmid}`, 5, source$);
  }

  getLicensesDeletedByUser(mdmid: string): Observable<CompleteLicense[]> {
    return this.http.get<CompleteLicense[]>(`License/LicensesEliminatedByUser?userId=${mdmid}`)
      .pipe(
        map((licenses) => licenses.map((license) => (
          {
            ...license,
            equipments: license.equipments.map((equipment) => (
              {
                ...equipment,
                equipmentStatus: equipment.equipmentStatus !== 'Eliminadas' ? equipment.equipmentStatus : 'Eliminado',
              }
            )),
          }
        ))),
      );
  }

  getInfractions(userId: string): Observable<Infractions[]> {
    return this.http.get<Infractions[]>(`MyProfile/InfringementsByUser?userId=${userId}`);
  }

  getLicenseDetailWithIds(licenseId: number): Observable<LicenseDetailWithIds> {
    return this.http.get<LicenseDetailWithIds>(`/License/Details/RequirementExpansion/GetById?licenseId=${licenseId}`);
  }

}
